module.exports = __webpack_public_path__ + "img/53-978ec4.png";